import { createRequest } from '@shared/services';

async function getComponentMenu(): Promise<BaseComponentMenuResponse<BaseMenuNodes>>;
async function getComponentMenu(
    id: string,
    isBuyer?: boolean
): Promise<BaseComponentMenuResponse<DetailMenuNodes[]>>;
async function getComponentMenu(
    id?: string,
    isBuyer?: boolean
): Promise<
    | BaseComponentMenuResponse<BaseMenuNodes>
    | BaseComponentMenuResponse<DetailMenuNodes[]>
    | null
> {
    const baseUrl = isBuyer ? '/menu' : '/component/menu';

    const url = `${baseUrl}${id ? `/${id}` : ''}`;

    const request = createRequest<
        | BaseComponentMenuResponse<BaseMenuNodes>
        | BaseComponentMenuResponse<DetailMenuNodes[]>
    >({
        url,
        method: 'GET',
        withAuthorization: true,
    });

    return request.execute();
}

export async function postComponentMenu(payload: BaseMenuPayload) {
    const request = createRequest<BaseComponentMenuResponse<BaseMenuNodes>>({
        url: '/component/menu',
        method: 'POST',
        data: payload,
        withAuthorization: true,
    });

    return request.execute();
}

export async function putComponentMenu(id: string, payload: BaseMenuPayload) {
    const request = createRequest<BaseComponentMenuResponse<BaseMenuNodes>>({
        url: `/component/menu/${id}`,
        method: 'PUT',
        data: payload,
        withAuthorization: true,
    });

    return request.execute();
}

export async function deleteComponentMenu(id: string) {
    const request = createRequest<DeleteComponentMenuResponse>({
        url: `/component/menu/${id}`,
        method: 'DELETE',
        withAuthorization: true,
    });

    return request.execute();
}

export { getComponentMenu };
